export default "__VITE_ASSET__7b396ff2__"